import { useState, useContext } from 'react';
import Box from '@mui/material/Box';  
import { SignIn, SignInBtn, getSupportedLang } from '@alfred-systems/frontend-shared-components';
import CircularIndeterminate from '../utils/Progress';
import ErrorMessageContext from '../context/ErrorMessageContext';
import signInLocales from '../../locales/signin';

const userLanguage = getSupportedLang();

// shared-components uses it for the jid resource and the ALFRED_FEEDBACK_FORM_SETTINGS localStorage key
export const PRODUCT_NAME = 'feedbackForm';

export default function SignInContainer ({
  show,
  onComplete
}) {
  const [isLoginFinish, setIsLoginFinish] = useState(false);
  const { onError }  = useContext(ErrorMessageContext);

  async function onSignInSuccess({ email, kvToken, uid }) {
    try {
      setIsLoginFinish(true);
      onComplete(email, kvToken, uid);
    } catch (err) {
      onError(err);
    }
  }

  const SignInPage = ({ signInWithGoogle, signInWithApple, goSignInWithEmailPage }) => { 
    return <div className='signin' style={{ maxWidth: 310, margin: 'auto' }}>
      <div onClick={signInWithGoogle} style={{ width: '100%' }}>
        <SignInBtn type='google' />
      </div>
      <div onClick={goSignInWithEmailPage} style={{ width: '100%' }}>
        <SignInBtn type='email' />
      </div>
      <div onClick={signInWithApple} style={{ width: '100%' }}>
        <SignInBtn type='apple' />
      </div>
    </div>
  }

  return <Box className='signin-container' sx={{ height: '100%', backgroundColor: '#fafafa', position: 'relative', display: show ? 'block' : 'none' }}>
    <CircularIndeterminate show={!isLoginFinish} style={{ background: '#fafafa' }} />
    <SignIn
      locale={userLanguage}
      messages={signInLocales[userLanguage]}
      role='signin'
      productName={PRODUCT_NAME}
      backToSignIn={true}
      productVersion='SignIn'
      onSignInSuccess={onSignInSuccess}
      retryPasswordTooManyTimes={()=>{}}
      networkError={()=>{}}
      apiError={()=>{}}
      unVerifiedError={()=>{}}
      onNotSignIn={() => setIsLoginFinish(true)}
      onEmailSignIn={()=>{}}
    >
      <SignInPage />
    </SignIn>
  </Box>
}